/*
  HISTORYページ冒頭の日本時間の時計

  実装仕様
  #1 閲覧者がどこの国にいても**日本時間**を出す。日本は1952年以降サマータイムが
     無く、UTC+9 から動かない。そのため Intl のタイムゾーン計算に頼らず、
     UTC に9時間足して UTC 側の getter で読む。Intl のタイムゾーン対応が
     欠けている環境でも同じ結果になる
  #2 サーバー側（Liquid）では出さない。Shopifyのページキャッシュに古い時刻が
     載りうるうえ、ストアのタイムゾーンが日本とは限らないため。
     JSが動いたときだけ --ready を付けて見せる
  #3 秒の頭に合わせて進める。setInterval(1000) だけだと端数がずれて
     表示が1秒飛ぶことがある
  #4 タブが裏に回っている間は止める。表に戻ったらすぐ描き直す
  #5 shopify:section:load / unload に対応する（テーマエディタでの編集中に
     古いタイマーが残らないようにする）
*/
(function () {
  'use strict';

  var SELECTOR = '[data-c-history-clock]';
  var READY_CLASS = 'c-history-intro__clock--ready';
  var JST_OFFSET_MS = 9 * 60 * 60 * 1000;

  var clocks = [];
  var timer = null;

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  /* 実装仕様 #1 */
  function format(now) {
    var jst = new Date(now.getTime() + JST_OFFSET_MS);
    return (
      jst.getUTCFullYear() +
      '/' +
      pad(jst.getUTCMonth() + 1) +
      '/' +
      pad(jst.getUTCDate()) +
      ' ' +
      pad(jst.getUTCHours()) +
      ':' +
      pad(jst.getUTCMinutes()) +
      ':' +
      pad(jst.getUTCSeconds())
    );
  }

  function paint() {
    var now = new Date();
    var text = format(now);
    var stamp = now.toISOString();

    for (var i = 0; i < clocks.length; i++) {
      var el = clocks[i];
      var time = el.querySelector('[data-c-history-clock-time]');
      if (!time) continue;
      time.textContent = text;
      time.setAttribute('datetime', stamp);
      el.classList.add(READY_CLASS);
    }
  }

  /* 実装仕様 #3 */
  function tick() {
    paint();
    timer = window.setTimeout(tick, 1000 - (Date.now() % 1000));
  }

  function start() {
    stop();
    if (clocks.length === 0) return;
    /*
      実装仕様 #4。裏で開かれたタブは visibilitychange が飛んでこないので、
      ここでも見ておく。見ていないと、一度も表に出ていないタブで
      1秒ごとの書き換えが回り続ける
    */
    if (document.hidden) {
      paint();
      return;
    }
    tick();
  }

  function stop() {
    if (timer === null) return;
    window.clearTimeout(timer);
    timer = null;
  }

  function collect() {
    clocks = Array.prototype.slice.call(document.querySelectorAll(SELECTOR));
    start();
  }

  /* 実装仕様 #4 */
  function onVisibility() {
    if (document.hidden) {
      stop();
    } else {
      start();
    }
  }

  collect();
  document.addEventListener('visibilitychange', onVisibility);

  /* 実装仕様 #5 */
  document.addEventListener('shopify:section:load', collect);
  document.addEventListener('shopify:section:unload', collect);
})();
